// View Queue Action Types
export const ViewQueueTypes = {
  // Fetch user queues
  FETCH_USER_QUEUES_REQUEST: 'VIEW_QUEUE_FETCH_USER_QUEUES_REQUEST',
  FETCH_USER_QUEUES_SUCCESS: 'VIEW_QUEUE_FETCH_USER_QUEUES_SUCCESS',
  FETCH_USER_QUEUES_FAILURE: 'VIEW_QUEUE_FETCH_USER_QUEUES_FAILURE',
  
  // Create queue
  CREATE_QUEUE_REQUEST: 'VIEW_QUEUE_CREATE_QUEUE_REQUEST',
  CREATE_QUEUE_SUCCESS: 'VIEW_QUEUE_CREATE_QUEUE_SUCCESS',
  CREATE_QUEUE_FAILURE: 'VIEW_QUEUE_CREATE_QUEUE_FAILURE',
  
  // Update queue
  UPDATE_QUEUE_REQUEST: 'VIEW_QUEUE_UPDATE_QUEUE_REQUEST',
  UPDATE_QUEUE_SUCCESS: 'VIEW_QUEUE_UPDATE_QUEUE_SUCCESS',
  UPDATE_QUEUE_FAILURE: 'VIEW_QUEUE_UPDATE_QUEUE_FAILURE',
  
  // Delete queue
  DELETE_QUEUE_REQUEST: 'VIEW_QUEUE_DELETE_QUEUE_REQUEST',
  DELETE_QUEUE_SUCCESS: 'VIEW_QUEUE_DELETE_QUEUE_SUCCESS',
  DELETE_QUEUE_FAILURE: 'VIEW_QUEUE_DELETE_QUEUE_FAILURE',
  
  // Add video to queue
  ADD_VIDEO_TO_QUEUE_REQUEST: 'VIEW_QUEUE_ADD_VIDEO_TO_QUEUE_REQUEST',
  ADD_VIDEO_TO_QUEUE_SUCCESS: 'VIEW_QUEUE_ADD_VIDEO_TO_QUEUE_SUCCESS',
  ADD_VIDEO_TO_QUEUE_FAILURE: 'VIEW_QUEUE_ADD_VIDEO_TO_QUEUE_FAILURE',
  
  // Remove video from queue
  REMOVE_VIDEO_FROM_QUEUE_REQUEST: 'VIEW_QUEUE_REMOVE_VIDEO_FROM_QUEUE_REQUEST',
  REMOVE_VIDEO_FROM_QUEUE_SUCCESS: 'VIEW_QUEUE_REMOVE_VIDEO_FROM_QUEUE_SUCCESS',
  REMOVE_VIDEO_FROM_QUEUE_FAILURE: 'VIEW_QUEUE_REMOVE_VIDEO_FROM_QUEUE_FAILURE',
  
  // Reorder videos in queue
  REORDER_QUEUE_VIDEOS_REQUEST: 'VIEW_QUEUE_REORDER_QUEUE_VIDEOS_REQUEST',
  REORDER_QUEUE_VIDEOS_SUCCESS: 'VIEW_QUEUE_REORDER_QUEUE_VIDEOS_SUCCESS',
  REORDER_QUEUE_VIDEOS_FAILURE: 'VIEW_QUEUE_REORDER_QUEUE_VIDEOS_FAILURE',
  
  // Search public queues
  SEARCH_QUEUES_REQUEST: 'VIEW_QUEUE_SEARCH_QUEUES_REQUEST',
  SEARCH_QUEUES_SUCCESS: 'VIEW_QUEUE_SEARCH_QUEUES_SUCCESS',
  SEARCH_QUEUES_FAILURE: 'VIEW_QUEUE_SEARCH_QUEUES_FAILURE',
  
  // UI state
  SET_SELECTED_QUEUE: 'VIEW_QUEUE_SET_SELECTED_QUEUE',
  CLEAR_SELECTED_QUEUE: 'VIEW_QUEUE_CLEAR_SELECTED_QUEUE',
  UPDATE_QUEUE_FILTERS: 'VIEW_QUEUE_UPDATE_QUEUE_FILTERS',
  SET_QUEUE_VIEW_MODE: 'VIEW_QUEUE_SET_QUEUE_VIEW_MODE',
  SET_ACTIVE_TAB: 'VIEW_QUEUE_SET_ACTIVE_TAB',
  TOGGLE_CREATE_MODAL: 'VIEW_QUEUE_TOGGLE_CREATE_MODAL',
  TOGGLE_EDIT_MODAL: 'VIEW_QUEUE_TOGGLE_EDIT_MODAL',
  
  // Queue player action types
  LOAD_QUEUE_FOR_PLAYBACK_REQUEST: 'VIEW_QUEUE_LOAD_QUEUE_FOR_PLAYBACK_REQUEST',
  LOAD_QUEUE_FOR_PLAYBACK_SUCCESS: 'VIEW_QUEUE_LOAD_QUEUE_FOR_PLAYBACK_SUCCESS',
  LOAD_QUEUE_FOR_PLAYBACK_FAILURE: 'VIEW_QUEUE_LOAD_QUEUE_FOR_PLAYBACK_FAILURE',
  SET_QUEUE_PLAYBACK_INDEX: 'VIEW_QUEUE_SET_QUEUE_PLAYBACK_INDEX',
  NEXT_QUEUE_VIDEO: 'VIEW_QUEUE_NEXT_QUEUE_VIDEO',
  PREVIOUS_QUEUE_VIDEO: 'VIEW_QUEUE_PREVIOUS_QUEUE_VIDEO',
  TOGGLE_QUEUE_AUTOPLAY: 'VIEW_QUEUE_TOGGLE_QUEUE_AUTOPLAY',
  CLEAR_QUEUE_PLAYBACK: 'VIEW_QUEUE_CLEAR_QUEUE_PLAYBACK',
  UPDATE_QUEUE_TIMESTAMP: 'VIEW_QUEUE_UPDATE_QUEUE_TIMESTAMP',
  
  // Watchlist actions
  ADD_TO_WATCHLIST_REQUEST: 'VIEW_QUEUE_ADD_TO_WATCHLIST_REQUEST',
  ADD_TO_WATCHLIST_SUCCESS: 'VIEW_QUEUE_ADD_TO_WATCHLIST_SUCCESS',
  ADD_TO_WATCHLIST_FAILURE: 'VIEW_QUEUE_ADD_TO_WATCHLIST_FAILURE',
  
  // Fetch a single public queue (guest-safe)
  FETCH_PUBLIC_QUEUE_REQUEST: 'VIEW_QUEUE_FETCH_PUBLIC_QUEUE_REQUEST',
  FETCH_PUBLIC_QUEUE_SUCCESS: 'VIEW_QUEUE_FETCH_PUBLIC_QUEUE_SUCCESS',
  FETCH_PUBLIC_QUEUE_FAILURE: 'VIEW_QUEUE_FETCH_PUBLIC_QUEUE_FAILURE'
};